module.exports = __webpack_public_path__ + "img/grass-4.b9aee02d.png";